import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LinearProgressComponent } from './linear-progress.component';

@Injectable({providedIn: 'root'})
export class LoaderService {
  private timeout: any;
  private overlayRef: OverlayRef;
  private visible: boolean;

  constructor(
    private overlay: Overlay,
  ) {
  }

  show(): void {
    if (this.visible) {
      return;
    }
    if (this.overlayRef) {
      this.visible = true;
      return;
    }
    this.visible = true;
    const positionStrategy = this.overlay.position().global().top().left();
    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'loader-backdrop',
      width: '100%'
    });
    const componentPortal = new ComponentPortal(LinearProgressComponent);
    this.overlayRef.attach(componentPortal);
  }

  hide(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.visible = false;
    this.timeout = setTimeout(() => {
      if (this.visible || !this.overlayRef) {
        return;
      }
      this.overlayRef.dispose();
      delete this.overlayRef;
    }, 300);
  }
}
